// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".co-chain-invoke-dialog.common-dialog[data-v-32455936] .el-dialog{width:var(--common-dialog-medium-width)}.co-chain-invoke-dialog.common-dialog .el-form[data-v-32455936]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
